import AwsS3Service from '../../../services/AwsS3Service';
import ProductServiceV2 from '../../../services/v2/ProductServiceV2';
import productUseCaseV2 from './productUseCaseV2';

const productFactoryV2 = productUseCaseV2({
  ProductServiceV2: ProductServiceV2(),
  AwsS3Service: AwsS3Service(),
});

export default productFactoryV2;
